export let useManagedQueryFailed = "Pg0si";
export let useManagedQuerySubmitFeedback = "jwzDF";
export default {useManagedQueryFailed,useManagedQuerySubmitFeedback};